import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ViewContainerRef } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { ActivatedRoute, Router } from '@angular/router';
import { map, take, tap } from 'rxjs';
import { IsNotUserDirective } from 'src/app/directves/is-not-user.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { AnswersStore } from 'src/app/store/answers-store';
import { LoggedUserComponent } from 'src/app/shared/components/logged-user/logged-user.component';
import { EQuestionnaireStatus } from 'src/app/models/questionnaireGrid.model';
import { AnswerQuestionnarieLowerNavComponent } from '../answer-questionnarie-lower-nav/answer-questionnarie-lower-nav';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';

@Component({
    selector: 'que-board-header',
    imports: [CommonModule, MatButtonToggleModule, TranslateDirective, TranslatePipe, IsNotUserDirective, ReactiveFormsModule, LoggedUserComponent, AnswerQuestionnarieLowerNavComponent],
    templateUrl: './board-header.component.html',
    styleUrls: ['./board-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoardHeaderComponent {

  @Input()
  isPreview = false;

  #questionnaireStore = inject(QuestionnaireStore);
  #answersStore = inject(AnswersStore);
  #router = inject(Router);
  #activeRoutes = inject(ActivatedRoute);
  #manipulationStore = inject(ManipulationsToolbarStore);

  notLoadingSave$ = toSignal(this.#answersStore.loadingSave$.pipe(map(x => !x)));
  questionnaireGuid$ = toSignal(this.#answersStore.questionnaireGuid$);
  isDisplayUser$ = toSignal(this.#manipulationStore.isDisplayUser$)
  isEdit: boolean = true;
  eQuestionnaireStatus = EQuestionnaireStatus;
  statusNotEdit$ = toSignal(this.#questionnaireStore.status$.pipe(map(st => st != EQuestionnaireStatus.Edit)));

  notLoading$ = toSignal(this.#questionnaireStore.notLoading$);

  id = 0;
  isUser$ = toSignal(inject(QuestionnaireStore).isUser$);

  ngOnInit(): void {

    // Retrieve parameters from the query string
    this.#activeRoutes.queryParams.subscribe(params => {
      var p = params['isNotEdit']
      if (p != undefined) {
        this.isEdit = !p; // replace 'yourParamName' with the actual parameter name
      }
    });
    this.isPreview = this.#router.url.includes("preview") || this.#router.url.includes("answer");
    this.#questionnaireStore.questionnaire$.pipe(take(2)).subscribe(
      q => {
        this.id = q.id
      });
  }

  goToPreview() {
    this.#router.navigate([`create/${this.id}/preview`])
  }
  returnFromPreview() {
    this.#router.navigate([`create/${this.id}/board`]);
  }

  goToMyQuestionnaire() {
    this.#answersStore.saveAnswers();
    this.#router.navigate([`main`]);
  }
  back() {
    this.#router.navigate([`create/${this.id}/board`])
  }

  save() {
    this.#answersStore.saveAnswers();
  }
}
